import { core } from "@servicetitan/hammer-token";
import { GapSize } from "../../types";

type PrimitiveSizes =
  | "Size0"
  | "SizeHalf"
  | "Size1"
  | "Size2"
  | "Size3"
  | "Size4"
  | "Size5"
  | "Size6"
  | "Size7"
  | "Size8"
  | "Size9"
  | "Size10"
  | "Size11"
  | "Size12"
  | "Size13"
  | "Size14";

export const sizeToToken = (value?: GapSize) => {
  if (typeof value === "undefined") return undefined;
  let gap = value;
  const stringifiedValue = String(value);
  if (stringifiedValue === "half") {
    gap =
      `${stringifiedValue[0].toUpperCase()}${stringifiedValue.slice(1)}` as GapSize;
  }

  return core.primitive?.[`Size${gap}` as PrimitiveSizes]?.value;
};
